import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import MercadoPagoOpcion from './mercado-pago-opcion';
import PagoEnAgenciaOpcion from './pago-en-agencia-opcion';
import PuntoDeVentaImg from '../../../../assets/images/punto-venta.png';
import './paquetes-checkout-formas-pago.css';

const FormasPago = (props) => {
  const countryId = useSelector((state) => state.applicationState.paisId);

  const { t } = useTranslation('translations');
  const formaPagoElegida = (props.formaPago === 'mercadopago')
    ? (
      <MercadoPagoOpcion />
    )
    : (
      <PagoEnAgenciaOpcion precio={props.precio} paquete={props.paquete} />
    );

  const styles = {
    containerLaber: {
      display: 'flex',
      flexDirection: 'row',
    },
    puntoPagoLabel: {
      fontSize: '19px',
      textTransform: 'initial',
      color: '#252323',
    },
    puntoDePagoImg: {
      height: 46,
      marginRight: 7,
      marginTop: '-5px',
    },
  };
  /* eslint-disable */
  const armarFormasPago = () => 
    props.canalesPago.map((canalPago) => {
      switch (canalPago.canalPagoDescripcion) {
        case 'mercadopago':
          return parseInt(countryId) === 1 ? (
            <div key={canalPago.canalPagoDescripcion} className='col-span-1 '>
              <div className='container bg-white my-4 p-4'>
                <div className='grid grid-cols-2'>
                    <div className="col-span-1">
                      <input
                        type='radio'
                        onClick={props.actualizarFormaPago}
                        name='metodopago'
                        className='radio-position'
                        value='mercadopago'
                        defaultChecked={props.formaPago === 'mercadopago'}
                        id='mercadopago'
                      />
                    </div>
                    <label htmlFor='mercadopago' className='label-ratio'>
                        <img
                          src={`/assets/img/pagos/mercadopago.png`}
                          className='h-12'
                          alt='mercadopago'
                        />
                      </label>
                  </div>
                  <div className='text-sm antialiased font-light text-grey-600 py-6'>
                      Paga en cuotas con bancos seleccionados
                      <a
                        className='inline-block color-dinamico'
                        href='https://www.mercadopago.com.ar/cuotas'
                        target='_blank'
                        rel='noopener noreferrer'
                      >
                        VER PROMOS
                      </a>
                    </div>
                </div>
              
            </div>
          ) : null;
          break;
        case 'deposito':
          return (
            <div key={canalPago.canalPagoDescripcion} className='col-span-1 '>
              <div className='container bg-white my-4 p-4'>
                  <div className='grid grid-cols-3'>
                    <div className="col-span-1">
                      <input
                        type='radio'
                        onClick={props.actualizarFormaPago}
                        name='metodopago'
                        className='radio-position'
                        value='deposito'
                        defaultChecked={props.formaPago === 'deposito'}
                        id='deposito'
                      />
                    </div>
                    <div className="col-span-2">
                    <label  htmlFor='deposito'>
                        <div className='flex flex-grow'>
                          <img
                            src={PuntoDeVentaImg}
                            className='img-responsive'
                            alt='Punto de venta'
                            style={styles.puntoDePagoImg}
                          />
                          <span className='text-3xl font-color-mbr-color-primario mb-2'>
                            {t('checkout.travelAgencyPayment')}
                          
                          </span>
                        </div>
                      </label>
                      </div>
                  </div>
                  <div className='text-sm antialiased font-light text-grey-600 py-6'>
                  {t('checkout.travelAgencyPaymentTip')}
                    </div>
                </div>
              </div>
          );
          break;
      }
    }
  );
  /* eslint-enable */

  return (
    <div>

      <div className='col-lg-12'>
        <h3 className='text-2xl font-color-mbr-color-primario mb-2'>Como quieres abonar el viaje?</h3>
      </div>
      <div className='grid-cols-2 gap-4 md:grid grid-cols-1 '>
        { armarFormasPago()}

        {/* QUITAMOS FINANCIACION TEMPORALMENTE YA QUE HAY QUE ACOMODAR EL MODAL Y ES SOLO PARA ARG <div>{formaPagoElegida}</div> */}
      </div>

    </div>
  );
};

export default FormasPago;
